import { render, staticRenderFns } from "./pasteUpload.vue?vue&type=template&id=4a9adcde&scoped=true&"
import script from "./pasteUpload.vue?vue&type=script&lang=js&"
export * from "./pasteUpload.vue?vue&type=script&lang=js&"
import style0 from "./pasteUpload.vue?vue&type=style&index=0&id=4a9adcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9adcde",
  null
  
)

export default component.exports